import { render, staticRenderFns } from "./KycOsvItem.vue?vue&type=template&id=4dc0f8dd&scoped=true&"
import script from "./KycOsvItem.vue?vue&type=script&lang=js&"
export * from "./KycOsvItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=4dc0f8dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0f8dd",
  null
  
)

export default component.exports